
import * as React from "react";
import { DayPicker } from "react-day-picker";

import { cn } from "@/lib/utils";
import { CustomCaption } from "./calendar/CustomCaption";
import { IconLeft, IconRight } from "./calendar/CalendarIcons";
import { getCalendarClassNames } from "./calendar/calendarStyles";
import { EventPropagationStopper } from "./calendar/EventPropagationStopper";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  const [selectedMonth, setSelectedMonth] = React.useState<Date>(
    props.defaultMonth || new Date()
  );

  return (
    <EventPropagationStopper className="calendar-wrapper">
      <DayPicker
        showOutsideDays={showOutsideDays}
        className={cn("p-3 pointer-events-auto calendar-wrapper", className)}
        classNames={getCalendarClassNames(classNames)}
        components={{
          IconLeft,
          IconRight,
          Caption: (captionProps) => (
            <CustomCaption 
              {...captionProps} 
              selectedMonth={selectedMonth} 
              setSelectedMonth={setSelectedMonth} 
            />
          ),
        }}
        month={selectedMonth}
        onMonthChange={setSelectedMonth}
        onDayClick={(day, modifiers, e) => {
          // Stop propagation to prevent closing popover
          e.stopPropagation();
          
          // Call the original handler if provided
          if (props.onDayClick) {
            props.onDayClick(day, modifiers, e);
          }
        }}
        {...props}
      />
    </EventPropagationStopper>
  );
}
Calendar.displayName = "Calendar";

export { Calendar };
